// Single import point for packages/moderation, imported from source like core and
// match (its nostr-tools comes from apps/web's node_modules; see scripts/build.mjs).
export * from "../../../../../packages/moderation/src/index.ts";
